import { FC } from "react";
import { Abonnement } from "../../lib/interfaces/abonnement.interface";
import { formatDate } from "../../lib/helpers/date_helpers";
import clsx from "clsx";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { Download, MoreVertical } from "lucide-react";
import { Button } from "../ui/button";

interface Props {
  abo: Abonnement;
}

const AbonnementItem: FC<Props> = ({ abo }) => {
  const hasRevue = abo.revue || abo.revueNumerique;

  return (
    <div className='border-l-2 border-indigo-900 pl-4'>
      <div className='flex justify-between items-center'>
        <div>
          <div className='font-semibold'>
            Du {formatDate(abo.dateDebut)} au {formatDate(abo.dateFin)}
          </div>
          <div className='flex gap-3 mt-1'>
            <div
              className={clsx("text-sm px-3 py-1 rounded-lg", {
                "bg-green-200": hasRevue,
                "bg-red-200": !hasRevue,
              })}
            >
              <span className='font-medium'>Revue :</span> {hasRevue ? (abo.revue ? "Papier" : "Numérique") : "Non"}
            </div>
            <div
              className={clsx("text-sm px-3 py-1 rounded-lg", {
                "bg-green-200": abo.citeo,
                "bg-red-200": !abo.citeo,
              })}
            >
              <span className='font-medium'>Eco-contribution :</span>{" "}
              {abo.citeo ? `Oui (${abo.ruches} ruche${abo.ruches === 1 ? "" : "s"})` : "Non"}
            </div>
          </div>
        </div>
        {abo.citeo && (
          <div>
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button className='text-slate-500' variant={"ghost"} size={"icon"}>
                  <MoreVertical />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent>
                <DropdownMenuLabel>Eco-contribution</DropdownMenuLabel>
                <DropdownMenuSeparator />
                <DropdownMenuItem
                  onClick={() => {
                    window.open(
                      "https://www.snapiculture.com/wp-content/uploads/2023/03/CITEO_INFO_TRI_EMBALLAGES_MAJ-26_4_2022.pdf",
                      "_blank"
                    );
                  }}
                >
                  <Download className='w-4 h-4 text-gray-700 mr-4' />
                  Kit info-tri
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        )}
      </div>
    </div>
  );
};

export default AbonnementItem;
